import React from 'react'
import * as classes from './CorporateGovernance.module.scss'
import IconPdf from './IconPdf'
import IconWord from './IconWord'
import IconPpt from './IconPpt'
import { Button } from '../../ui/Button/Button'
import { getFileType, getFileTypeLabel, getFileDownloadLabel } from '../../../utils/getFileType'

const fileIcons = {
    pdf: IconPdf,
    word: IconWord,
    ppt: IconPpt
}

function Item({ files, onFormatBytes, lang }) {
    return (
        <div>
            {files.map((file, fileIndex) => {
                const fileType = getFileType(file?.file?.mimeType, file?.file?.url)
                const FileIcon = fileIcons[fileType]

                return (
                    <div className={classes.File} key={fileIndex}>
                        <div className={classes.IconPdfWrap}>
                            <FileIcon />
                        </div>

                        <div className={classes.FileContent}>
                            {file?.name && <div className={classes.FileText} dangerouslySetInnerHTML={{ __html: file.name }} />}

                            {file?.file?.size && (
                                <span className={classes.FileSize}>
                                    {getFileTypeLabel(fileType)}, {onFormatBytes(file.file.size)} Mb
                                </span>
                            )}
                        </div>

                        <Button className={classes.FileBtn} onClick={() => window.open(file?.file?.url, '_blank', 'noopener,noreferrer')}>
                            {getFileDownloadLabel(fileType, lang)}
                        </Button>
                    </div>
                )
            })}
        </div>
    )
}

export default Item
